export const products = (state = [], action) => {
  if (action.type === 'FETCH_PRODUCTS') {
    return action.payload;
  }
  if (action.type === 'CLEAR_PRODUCTS') {
    return [];
  }
  return state;
};

export const product = (state = {}, action) => {
  if (action.type === 'FETCH_PRODUCT') {
    return action.payload;
  }
  if (action.type === 'CLEAR_PRODUCT') {
    return {};
  }
  return state;
};

export const productIds = (state = [], action) => {
  if (action.type === 'FETCH_PRODUCT_IDS') {
    return action.payload;
  }
  if (action.type === 'CLEAR_PRODUCT_IDS') {
    return [];
  }
  return state;
};
